import * as React from 'react';
import { observer } from 'mobx-react';
import './officialBaseCard.module.scss';
import { SheLocation } from '../../../types/location';
import { LaunchOutlined, RoomOutlined, TrainOutlined } from '@material-ui/icons';
import { ImageApis } from '../../../../commonv3/api/images';
import { LazyImage } from '../../../../commonv3/components/atoms/images/LazyImage';

type Props = {
  location: SheLocation;
};

export const OfficialBaseCard = observer(({ location }: Props) => {
  return (
    <div styleName="base-card-wrapper">
      <div styleName="title">{location.name}</div>
      <div styleName="content">
        <div styleName="image-wrapper">
          {location.image && <LazyImage offset={100} src={ImageApis.getUrlFor(location.image)} styleName="image" />}
        </div>
        <div styleName="address">
          <RoomOutlined styleName="icon" />
          <span>
            〒{location.zipcode} {location.address}
          </span>
        </div>
        <div styleName="access-summary">
          <TrainOutlined styleName="icon" />
          {location.access_summary}
        </div>
      </div>
      <div styleName="map-button-wrapper">
        <div styleName="button">
          <a styleName="link" href={location.google_map_url} target="_blank">
            Google Mapで見る
            <LaunchOutlined styleName="link-icon" />
          </a>
        </div>
      </div>
    </div>
  );
});
